<template>
  <div
    class="card invisible-overlay-disabled mb-0 flex justify-start"
    :class="{ 'invisible-overlay-active': invisible }"
  >
    <ProgressSpinner
      :style="`width: ${size}rem; height: ${size}rem`"
      stroke-width="5"
      animation-duration="1s"
      aria-label="Custom ProgressSpinner"
      class="iai-spinner"
      :pt="{
        root: () => ({
          class: ['iai-spinner'],
        }),
      }"
    />
  </div>
</template>

<script setup lang="ts">
import ProgressSpinner from "primevue/progressspinner";

withDefaults(
  defineProps<{
    size?: number;
    invisible?: boolean;
  }>(),
  {
    size: 1,
    invisible: false,
  }
);
</script>

<style lang="scss" scoped>
.invisible-overlay-disabled {
  opacity: 1;
  visibility: visible;
  transition:
    opacity 0.1s,
    visibility 0.1s;
}

.invisible-overlay-active {
  opacity: 0;
  visibility: hidden;
}
</style>

<style lang="scss">
.iai-spinner {
  .p-progress-spinner-circle {
    animation: p-progress-spinner-dash 1.5s ease-in-out infinite;
  }
}
</style>
